import React from 'react'

const Loading = () => {
  return (
    <div style={{   color: '#ab7a5f',fontSize: '50px',
                    position: 'absolute',top:'50%',
                    left:'50%',transform:'translate(-50%,-50%)'}}>
                    Loading...</div>
  )
}

export default Loading